'use client'

import FabricCanvasTool from "../fabrictool"
import { fabric } from "@/@corefabriccanvas/fabric/dist/fabric"
import { SvgIcons } from "../../svgIcons"
class Pencil extends FabricCanvasTool {
  configureCanvas(props) {
    this._canvas.isDrawingMode = true
    this._canvas.freeDrawingBrush = new fabric.PencilBrush(this._canvas)
    this._canvas.freeDrawingBrush.width = props.lineWidth
    this._canvas.freeDrawingBrush.color = props.lineColor
    this._canvas.freeDrawingCursor = `url(${SvgIcons.getAsImageSrc(SvgIcons.Pencil)}) ${2} ${24}, crosshair`
  }
}

export default Pencil
